import React from 'react';

export const ProfilePage = React.lazy(() => import('./ProfilePage'));
